import React, { useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import Editor from 'src/components/Editor/Editor';

// Json Editor for json type KVS
const JsonEditorField = ({ data, onChangeField }) => {
  const displayLabel = data?.label || data?.caption || null;

  const valueStr = useMemo(() => {
    return typeof data?.value === 'string'
      ? data.value
      : JSON.stringify(data?.value ?? {}, null, 2);
  }, [data?.value]);

  return (
    <>
      {displayLabel && (
        <Typography
          variant="h6"
          component="label"
          htmlFor={data?.fld}
          gutterBottom
          style={{ display: 'block' }}
        >
          {displayLabel}
        </Typography>
      )}
      <Editor
        mode="json"
        readOnly={false}
        wrapperStyle={{ height: '260px' }}
        value={valueStr}
        onChange={value =>
          onChangeField({ target: { name: data?.fld || '', value } })
        }
      />
    </>
  );
};

export default JsonEditorField;
